/**
 * Интерактивы для контентных страниц:
 * - Отзывы: фильтр, "показать еще", анимация шкал
 * - Вакансии: фильтр карточек и аккордеон вакансий
 * - Блог (листинг): фильтр, поиск, "показать еще"
 * - Блог (детальная): подсветка активного пункта оглавления
 */

function setCardVisibility(cards, predicate) {
  cards.forEach((card) => {
    card.hidden = !predicate(card)
  })
}

function initReviewBars() {
  const bars = document.querySelectorAll('.reviews-hub__bar-fill')
  if (!bars.length) return

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return
        const percent = entry.target.dataset.value || '0'
        entry.target.style.width = `${percent}%`
        obs.unobserve(entry.target)
      })
    },
    { threshold: 0.35 }
  )

  bars.forEach((bar) => observer.observe(bar))
}

function initReviewsPage() {
  const root = document.querySelector('.reviews-hub')
  if (!root) return

  const filters = root.querySelectorAll('[data-review-filter]')
  const cards = Array.from(root.querySelectorAll('.reviews-hub__grid .reviews-hub-card'))
  const loadMoreBtn = root.querySelector('.reviews-hub__more')
  const cardsContainer = root.querySelector('.reviews-hub__grid')

  let activeFilter = 'all'
  let visibleCount = 8

  function passFilter(card) {
    if (activeFilter === 'all') return true
    return card.dataset.type === activeFilter
  }

  function rerender() {
    const filtered = cards.filter(passFilter)
    cards.forEach((card) => card.classList.remove('is-hidden-by-limit'))

    filtered.forEach((card, index) => {
      if (index >= visibleCount) card.classList.add('is-hidden-by-limit')
    })

    setCardVisibility(cards, (card) => passFilter(card) && !card.classList.contains('is-hidden-by-limit'))

    if (loadMoreBtn) {
      loadMoreBtn.hidden = filtered.length <= visibleCount
    }

    if (cardsContainer) {
      cardsContainer.dataset.filteredCount = String(filtered.length)
    }
  }

  filters.forEach((button) => {
    button.addEventListener('click', () => {
      activeFilter = button.dataset.reviewFilter || 'all'
      visibleCount = 8
      filters.forEach((item) => item.classList.remove('is-active'))
      button.classList.add('is-active')
      rerender()
    })
  })

  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', () => {
      visibleCount += 4
      rerender()
    })
  }

  rerender()
  initReviewBars()
}

function initVacancyPage() {
  const root = document.querySelector('.vacancy-page')
  if (!root) return

  const filterButtons = root.querySelectorAll('[data-vacancy-filter]')
  const vacancyCards = Array.from(root.querySelectorAll('.vacancy-openings__item'))
  const countNode = root.querySelector('.vacancy-openings__count strong')
  let activeTeam = 'all'

  function updateOpenings() {
    const visible = vacancyCards.filter((card) => {
      if (activeTeam === 'all') return true
      return card.dataset.team === activeTeam
    })

    setCardVisibility(vacancyCards, (card) => visible.includes(card))
    if (countNode) countNode.textContent = String(visible.length)
  }

  filterButtons.forEach((button) => {
    button.addEventListener('click', () => {
      activeTeam = button.dataset.vacancyFilter || 'all'
      filterButtons.forEach((item) => item.classList.remove('is-active'))
      button.classList.add('is-active')
      updateOpenings()
    })
  })

  const toggles = root.querySelectorAll('.vacancy-openings__toggle')
  toggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const item = toggle.closest('.vacancy-openings__item')
      if (!item) return

      const isOpen = item.classList.toggle('is-open')
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false')
    })
  })

  updateOpenings()
}

function initBlogListingPage() {
  const root = document.querySelector('.blog-hub')
  if (!root) return

  const filterButtons = root.querySelectorAll('[data-blog-filter]')
  const searchInput = root.querySelector('#blogSearch')
  const cards = Array.from(root.querySelectorAll('.blog-hub-card'))
  const loadMoreBtn = root.querySelector('.blog-hub__more')
  let activeCategory = 'all'
  let visibleCount = 9

  function passSearch(card, query) {
    if (!query) return true
    const text = `${card.dataset.title || ''} ${card.dataset.tags || ''}`.toLowerCase()
    return text.includes(query)
  }

  function passCategory(card) {
    if (activeCategory === 'all') return true
    return card.dataset.category === activeCategory
  }

  function rerender() {
    const query = (searchInput?.value || '').trim().toLowerCase()
    const filtered = cards.filter((card) => passCategory(card) && passSearch(card, query))
    cards.forEach((card) => card.classList.remove('is-hidden-by-limit'))

    filtered.forEach((card, index) => {
      if (index >= visibleCount) card.classList.add('is-hidden-by-limit')
    })

    setCardVisibility(cards, (card) => !card.classList.contains('is-hidden-by-limit') && filtered.includes(card))

    if (loadMoreBtn) {
      loadMoreBtn.hidden = filtered.length <= visibleCount
    }
  }

  filterButtons.forEach((button) => {
    button.addEventListener('click', () => {
      activeCategory = button.dataset.blogFilter || 'all'
      visibleCount = 9
      filterButtons.forEach((item) => item.classList.remove('is-active'))
      button.classList.add('is-active')
      rerender()
    })
  })

  if (searchInput) {
    searchInput.addEventListener('input', () => {
      visibleCount = 9
      rerender()
    })
  }

  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', () => {
      visibleCount += 6
      rerender()
    })
  }

  rerender()
}

function initBlogArticlePage() {
  const articleRoot = document.querySelector('.blog-article')
  if (!articleRoot) return

  const tocLinks = Array.from(articleRoot.querySelectorAll('.blog-article__toc a'))
  if (!tocLinks.length) return

  const headingMap = tocLinks
    .map((link) => {
      const id = link.getAttribute('href')?.replace('#', '')
      if (!id) return null
      const heading = articleRoot.querySelector(`#${id}`)
      if (!heading) return null
      return { link, heading }
    })
    .filter(Boolean)

  if (!headingMap.length) return

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return
        const current = headingMap.find((item) => item.heading === entry.target)
        if (!current) return
        tocLinks.forEach((link) => link.classList.remove('is-active'))
        current.link.classList.add('is-active')
      })
    },
    { rootMargin: '0px 0px -65% 0px', threshold: 0.1 }
  )

  headingMap.forEach((item) => observer.observe(item.heading))
}

export function initContentPages() {
  initReviewsPage()
  initVacancyPage()
  initBlogListingPage()
  initBlogArticlePage()
}
